import React, { useRef, useEffect, useState } from 'react';
import { useTheme } from '../ThemeContext';

// Import images
import image1 from './PartnerImages/1.jpg';
import image2 from './PartnerImages/2.jpg';
import image3 from './PartnerImages/3.jpg';
import image4 from './PartnerImages/4.jpg';
import image5 from './PartnerImages/5.jpg';
import image6 from './PartnerImages/6.jpg';
import image7 from './PartnerImages/7.jpg';
import image8 from './PartnerImages/8.jpg';
import image9 from './PartnerImages/9.jpg';
import image10 from './PartnerImages/10.jpg';
import image11 from './PartnerImages/11.jpg';
import image12 from './PartnerImages/12.jpg';
import image13 from './PartnerImages/13.jpg';
import image14 from './PartnerImages/14.jpg';
import image15 from './PartnerImages/15.jpg';

// Constants for different screen sizes
const DESKTOP = {
  LOGO_HEIGHT: 200,
  LOGO_WIDTH: 300,
  SPACING: 20,
  VISIBLE_LOGOS: 4
};

const MOBILE = {
  LOGO_HEIGHT: 150,
  LOGO_WIDTH: 200,
  SPACING: 10,
  VISIBLE_LOGOS: 1
};

const Partners = () => {
  const containerRef = useRef(null);
  const animationRef = useRef(null);
  const { currentTheme, themes } = useTheme();
  const theme = themes[currentTheme];
  const [dimensions, setDimensions] = useState(
    window.innerWidth < 768 ? MOBILE : DESKTOP
  );

  // Partner data with imported images
  const partners = [
    { id: '1', logo: image1 },
    { id: '2', logo: image2 },
    { id: '3', logo: image3 },
    { id: '4', logo: image4 },
    { id: '5', logo: image5 },
    { id: '6', logo: image6 },
    { id: '7', logo: image7 },
    { id: '8', logo: image8 },
    { id: '9', logo: image9 },
    { id: '10', logo: image10 },
    { id: '11', logo: image11 },
    { id: '12', logo: image12 },
    { id: '13', logo: image13 },
    { id: '14', logo: image14 },
    { id: '15', logo: image15 },
  ];

  // Double the partners array for seamless loop
  const extendedPartners = [...partners, ...partners];

  useEffect(() => {
    const handleResize = () => {
      setDimensions(window.innerWidth < 768 ? MOBILE : DESKTOP);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const startScrolling = () => {
      if (!containerRef.current) return;
      
      const contentWidth = (dimensions.LOGO_WIDTH + dimensions.SPACING) * partners.length;
      let currentPosition = 0;
      
      const animate = () => {
        if (!containerRef.current) return;
        
        currentPosition += 0.5; // Reduced speed for smoother animation
        
        if (currentPosition >= contentWidth) {
          currentPosition = 0;
        }
        
        containerRef.current.style.transform = `translateX(${-currentPosition}px)`;
        animationRef.current = requestAnimationFrame(animate);
      };
      
      animationRef.current = requestAnimationFrame(animate);
    };

    startScrolling();

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, [dimensions]);

  const styles = {
    outerContainer: {
      width: '100%',
      backgroundColor: theme.bgColor,
      padding: '20px 0',
      transition: 'background-color 0.3s ease',
      overflow: 'hidden',
    },
    heading: {
      color: theme.textColor,
      fontSize: window.innerWidth < 768 ? '24px' : '28px',
      fontWeight: '600',
      marginBottom: '30px',
      textAlign: 'center',
      padding: '0 20px',
    },
    container: {
      height: `${dimensions.LOGO_HEIGHT + 40}px`,
      backgroundColor: theme.bgColor,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%',
      transition: 'background-color 0.3s ease',
    },
    marqueeContainer: {
      height: `${dimensions.LOGO_HEIGHT}px`,
      overflow: 'hidden',
      width: '100%',
      position: 'relative',
    },
    logosContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      position: 'absolute',
      left: '0',
      top: '0',
      willChange: 'transform',
      transition: 'transform 0.1s linear',
    },
    logoWrapper: {
      width: `${dimensions.LOGO_WIDTH}px`,
      height: `${dimensions.LOGO_HEIGHT}px`,
      margin: `0 ${dimensions.SPACING / 2}px`,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexShrink: 0,
    },
    logo: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
      borderRadius: '12px',
      backgroundColor: theme.bgColor,
    },
  };

  return (
    <div style={styles.outerContainer}>
      <h2 style={styles.heading}>OUR PARTNERS</h2>
      <div style={styles.container}>
        <div style={styles.marqueeContainer}>
          <div ref={containerRef} style={styles.logosContainer}>
            {extendedPartners.map((partner, index) => (
              <div key={`${partner.id}-${index}`} style={styles.logoWrapper}>
                <img
                  src={partner.logo}
                  alt={`Partner ${partner.id}`}
                  style={styles.logo}
                  loading="lazy"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Partners;